import { LegacyTask } from '../task/legacy-task.model';
import { ActivityTaskActivity } from 'ng2-app/modules/task-management/models/activity-task/activity-task-activity.class';

export class ActivityTask extends LegacyTask {
    tasks: ActivityTaskActivity[];
}
